import { cropName } from 'helpers/cropName'
import { FC } from 'react'
import { cn, Avatar, AvatarFallback, AvatarImage } from '@wellesley/ui'

export type SideBarAvatarProps = {
  src?: string
  title: string
  className?: string
}

export const SideBarAvatar: FC<SideBarAvatarProps> = ({
  src,
  title,
  className,
}) => (
  <Avatar className={cn('ml-m mt-[-68px] h-24 w-24 rounded-full', className)}>
    <AvatarImage src={src} alt="app-avatar" />
    <AvatarFallback className="text-3xl font-semibold text-white">
      {cropName(title)}
    </AvatarFallback>
  </Avatar>
)
